import moment from 'moment'

export const now = () => new Date().toISOString()

export const displayDate = date => moment(date).format('MMMM Do YYYY, h:mm a')
